<template>
    <div class="step-3">
        <h2><trans msg="step3_title" /></h2>
        <p><trans msg="step3_description" /></p>

        <label><trans msg="step3_choose" /></label>

        <div class="color-wrapper">
            <div :class="invalid.indexOf('color') !== -1 ? 'error color-group' : 'color-group'">
                <color color="#d0011b" :active_color="custom_color" @activate="change_color" />
                <color color="#f6a623" :active_color="custom_color" @activate="change_color" />
                <color color="#f8e81c" :active_color="custom_color" @activate="change_color" />
                <color color="#222222" :active_color="custom_color" @activate="change_color" />
                <color color="#bd0fe1" :active_color="custom_color" @activate="change_color" />
                <color color="#4990E2" :active_color="custom_color" @activate="change_color" />
                <color color="#7ed321" :active_color="custom_color" @activate="change_color" />
            </div>
        </div>
        <p><trans msg="step3_post" /></p>
    </div>
</template>

<script>

import Color from './Color.vue'
import Translation from './Translation.vue'

export default {
  name: 'step-3',
  props: ['custom_color', 'invalid'],
  methods: {
    change_color: function(clr) {
        this.$emit('change_color', clr);
    }
  },
  components: {
    'color': Color,
    'trans': Translation
  }
}
</script>

<style scoped>
    .color-group {
        border: solid 1px #859299;
        padding: 7px 4px 0px 9px;
        border-radius: 4px;
        float: left;
        margin: 10px 0 20px;
    }

    .color-group.error {
        border-color: red;
    }

    .color-wrapper:after {
        content: '';
        display: block;
        float: none;
        clear: both;
    }
</style>



// WEBPACK FOOTER //
// Step3.vue?36249523